'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Tw = function Tw(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: 'Tweet', width: width, href: link, onClick: link ? undefined : _Actions2.default['twitter']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width }, props, { viewBox: '0 0 33 33' }),
      _react2.default.createElement(
        'title',
        null,
        title,
        ' button'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd', transform: 'translate(.603 1)' },
        _react2.default.createElement('ellipse', { cx: '15.696', cy: '15.703', rx: '15.696', ry: '15.703' }),
        _react2.default.createElement('path', { d: 'M21.802 11.744a3.279 3.279 0 0 0 1.437-1.808 6.54 6.54 0 0 1-2.075.793 3.268 3.268 0 0 0-5.567 2.981 9.274 9.274 0 0 1-6.734-3.415 3.268 3.268 0 0 0 1.011 4.364 3.253 3.253 0 0 1-1.48-.409v.041a3.27 3.27 0 0 0 2.62 3.205 3.272 3.272 0 0 1-1.475.056 3.27 3.27 0 0 0 3.052 2.27 6.553 6.553 0 0 1-4.837 1.354 9.244 9.244 0 0 0 5.008 1.468c6.01 0 9.296-4.98 9.296-9.3 0-.141-.004-.282-.01-.422a6.638 6.638 0 0 0 1.63-1.692 6.529 6.529 0 0 1-1.876.514z' })
      )
    )
  );
};

Tw.defaultProps = {
  title: "Tweet"
};

exports.default = Tw;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Twitter.js
// module id = 446
// module chunks = 168707334958949